import { api } from "@/lib/api";

export async function getLatestReport(campaignId) {
  const { data } = await api.get(`/campaigns/${campaignId}/report`);
  return data;
}
export async function generateReport(campaignId) {
  const { data } = await api.post(`/campaigns/${campaignId}/report/generate`);
  return data.report;
}
export async function markReportRead(campaignId) {
  const { data } = await api.post(`/campaigns/${campaignId}/report/mark-read`);
  return data.report;
}
export async function unreadReportsCount() {
  const { data } = await api.get(`/reports/unread-count`);
  return data.unread || 0;
}
